export const sectionLocations = {
  introduction: 0,
  features: 0,
  hangar: 0,
  roadmap: 0,
};
